<div class="client-select-dialog">
  <!-- Search bar -->
  <div class="search-bar">
    <div class="search-input-wrapper">
      <input class="search-input"
             type="text"
             [formControl]="searchControl"
             placeholder="Search residents"
             autocomplete="off"
             cdkFocusInitial>
      <div class="search-underline"></div>
    </div>
    <div class="filter-stack">
      <button class="filter-btn hcp" [class.active]="fundingFilter === 'hcp'" (click)="toggleFundingFilter('hcp')">HCP</button>
      <button class="filter-btn hpac" [class.active]="fundingFilter === 'hpac'" (click)="toggleFundingFilter('hpac')">HPAC</button>
    </div>
    <label class="inactive-toggle" (click)="toggleShowInactive()">
      <mat-icon class="inactive-check">{{ showInactive ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
      <span>Show inactive</span>
    </label>
    <button mat-flat-button
            color="primary"
            class="select-btn"
            [disabled]="!selectedClient"
            (click)="onSelect()">
      Select
    </button>
    <button mat-icon-button
            class="close-btn"
            (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Client grid -->
  <mat-dialog-content class="client-grid-container">
    <div class="client-grid">
      <button *ngFor="let client of filteredClients"
              class="client-tile"
              [class.selected]="isSelected(client)"
              (click)="onClientClick(client)">
        <div class="client-avatar">
          <img *ngIf="getPhoto(client.ResidentID)" [src]="getPhoto(client.ResidentID)" alt="">
          <mat-icon *ngIf="!getPhoto(client.ResidentID)">account_circle</mat-icon>
          <span *ngIf="client.is_hpac" class="funding-badge hpac">HPAC</span>
          <span *ngIf="client.has_hcp && !client.is_hpac" class="funding-badge hcp">HCP</span>
        </div>
        <span class="client-firstname">{{ client.FirstName }}</span>
        <span class="client-lastname">{{ client.LastName }}</span>
      </button>
    </div>
    <p class="no-results" *ngIf="filteredClients.length === 0">No residents match "{{ searchControl.value }}"</p>
  </mat-dialog-content>
</div>
